module.exports = __webpack_public_path__ + "static/media/icons-add-disable-24.a931788a.svg";